import React from 'react';

import Container from '../components/Container';
import CustomHead from '../components/CustomHead';
import Footer from '../components/FooterNew';
import Header from '../components/HeaderNew';

import Heading from '@components/Heading';

const Privacy = () => {
  return (
    <>
      {/* @ts-expect-error CustomHead is not typed */}
      <CustomHead
        meta={{
          title: 'Privacy Policy | PopSQL',
        }}
      />
      <main>
        <Header />

        <Container
          singleColumn
          className={
            'flex fade fade-1 px-10 pb-4 pt-12 md:pt-24 max-w-screen-xl w-full'
          }
        >
          <Heading Tag="h1" size="lg" className="text-center mb-4">
            Privacy Policy
          </Heading>

          {/* <a className="mx-auto font-inter font-medium text-2xl mt-8" href="#jobs">Join the team <span className="ml-2">-></span></a> */}
        </Container>

        <div className="fade fade-1 mx-auto px-16 md:px-0 w-full max-w-3xl space-y-8 my-5">
          <p>
            Effective <time dateTime="2024-04-03">April 3, 2024</time>, this
            website is owned and operated by Timescale, Inc.
          </p>
          <h3>General</h3>
          <p>
            Timescale Inc. ("we" or "us") values our customers and respects
            their privacy. This privacy policy ("Privacy Policy") governs our
            collection and use of data in connection our website (the "Site"),
            our applications, and any services we offer (collectively, the
            "Services"). Terms capitalized but not defined in this Privacy
            Policy shall have the meaning ascribed to them in our Terms of
            Service.
          </p>
          <p>
            This Privacy Policy sets forth the nature, purpose, use and sharing
            of any information that identifies or can be used to identify you,
            the visitors to the Site, and users of our Services ("Personal
            Information"). This Privacy Policy does not govern privacy practices
            associated with offline activities, websites other than ours, or
            practices of third parties that we do not own or control, such as
            our partners, third party service providers featured on the Site or
            in the Services or advertisers. If you have objections to the
            Privacy Policy, you should immediately discontinue use of the
            Services and follow the procedure described in the section entitled
            "Opting-Out or Updating Your Personal Information and Privacy
            Preferences."
          </p>
          <p>
            The Site and the Services are intended for adult audiences only, and
            we do not knowingly collect any Personal Information from anyone
            under 13 years of age. If you are under age 13, please do not
            provide any Personal Information about yourself to us. If we learn
            that we have collected Personal Information from a child under age
            13, we will delete that information as quickly as possible. If you
            believe that we might have any Personal Information from a child
            under the age of 13, please contact us immediately.
          </p>

          <h3>Changes in Privacy Policy</h3>
          <p>
            Any Personal Information that we collect and maintain will be
            subject to this Privacy Policy, as amended from time to time. We may
            change the Privacy Policy at our sole discretion. However, if at any
            time we make material changes to the Privacy Policy, we will notify
            you of those changes on the Site and through the publishing of an
            updated Privacy Policy. If as the result of such changes you want to
            alter the ways in which we are allowed to use your Personal
            Information, you can do so by following the procedure described in
            the section entitled "Opting-Out or Updating Your Personal
            Information and Privacy Preferences."
          </p>

          <h3>Collection of Information</h3>
          <ul className="list-disc space-y-3 ml-10 pr-5">
            <li>
              <p>
                We collect the Personal Information you give us when you
                register with the Site or use the Services, including name,
                address, credit card or bank information, and other Personal
                Information requested as part of your use of the Site or the
                Services, or the information you choose to give us when you use
                the Services. We automatically collect certain kinds of
                non-personal information from you when you use the Site or the
                Services, including device, browser type, operating system, CPU
                speed, referring or exit webpages, click patterns, Session ID,
                your computer's IP address, and metrics related to queries you
                run using the Services.
              </p>
            </li>
            <li>
              <p>
                We may on occasion supplement or correct the Personal
                Information you submit to us and your IP address with
                information in our other databases or information from
                third-party sources in order to reduce errors in our database,
                authenticate our users, prevent fraud and prevent abuse of our
                Site, as well as to provide more consistent, relevant
                experiences to our users.
              </p>
            </li>
            <li>
              <p>
                We may collect general information about use of the Site and the
                Services, such as what pages visitors access, the number of
                visits, average time spent on the Site and other similar
                factors. This information is generally collected in aggregate
                form, without identifying any user individually, although IP
                addresses and Session ID in relation to downloads may be tracked
                as part of our fraud prevention efforts.
              </p>
            </li>
          </ul>

          <h3>How Your Information is Used</h3>
          <p>
            Except as provided herein, we collect and use your personal and
            non-personal information for internal purposes only or for gathering
            aggregate and anonymized data, and we do not sell, rent, or share
            personally identifiable information about you with other people or
            with nonaffiliated companies except as described below. We may use
            your information in the following ways:
          </p>
          <ul className="list-disc space-y-3 ml-10 pr-5">
            <li>
              <p>
                To conduct routine business operations such as billing,
                identification, authentication, contact purposes and general
                research. As part of our routine business operations, we may
                transfer your Personal Information to certain third parties with
                whom we contract for the limited purpose of providing services
                such as web hosting, email, and credit card processing. These
                service providers are obligated to protect your information, and
                they do not use your Personal Information for their own
                commercial purposes.
              </p>
            </li>
            <li>
              <p>
                To employ internal marketing techniques such as tracking
                customer preferences to provide a customized Site experience and
                communicating with you about Services, special offers, and other
                services.
              </p>
            </li>
            <li>
              <p>To provide you with and enhance the Services.</p>
            </li>
            <li>
              <p>
                To gather generic product, location and other contributed
                information to make reports based on aggregate anonymized data,
                which we may use internally, or which we may share with others
                for a variety of purposes, including for their own uses.
              </p>
            </li>
            <li>
              <p>To comply with court and governmental orders.</p>
            </li>
          </ul>
          <p>
            PopSQL's use and transfer to any other app of information received
            from Google APIs will adhere to{' '}
            <a
              href="https://developers.google.com/terms/api-services-user-data-policy"
              target="_blank"
              rel="noreferrer"
            >
              Google API Services User Data Policy
            </a>
            , including the Limited Use requirements.
          </p>

          <h3>Tracking, Use of Cookies, Web Beacons and Similar Devices</h3>
          <p>
            In order to improve our Products and the App and provide more
            convenient, relevant experiences to our customers, we and our agents
            may use "cookies," "web beacons," and similar devices to track your
            activities. A cookie is a small amount of data that is transferred
            to your browser by a web server and can only be read by the server
            that gave it to you. It functions as your identification card and
            enables us to record your passwords and preferences. It cannot be
            executed as code or deliver viruses. A web beacon is a small
            transparent .gif image that is embedded in an HTML page or email
            used to track when the page or email has been viewed. Most browsers
            are initially set to accept cookies, and most services that include
            similar devices are typically initially activated to collect data.
            You can set your browser to notify you when you receive a cookie,
            giving you the chance to decide whether or not to accept it. We do
            not support browsers' Do Not Track features. You can enable or
            disable Do Not Track by visiting the preferences or settings page of
            your browser. We use an access token, similar to a cookie, for
            certain portions of the Services.
          </p>

          <h3>Protecting Your Information</h3>
          <p>
            We use a variety of security measures, including SSL, encryption,
            and authentication tools, to help protect your information. You can
            learn more about our security practices at our{' '}
            <a href={`${process.env.NEXT_PUBLIC_WEB_HOST}/security`}>
              Security
            </a>{' '}
            policies.
          </p>

          <h3>Your User Content</h3>
          <p>Your User Content will be treated as follows:</p>
          <ul className="list-disc space-y-3 ml-10 pr-5">
            <li>
              <p>
                We will store your preferences/settings on your device's hard
                drive.
              </p>
            </li>
            <li>
              <p>
                Queries you make using the Services are only accessible by you
                or by individuals you've authorized to view such queries.
              </p>
            </li>
            <li>
              <p>
                If and when the Services permit query result sharing, we will
                store query results on a cloud server using a third-party
                service provider such as AWS.
              </p>
            </li>
            <li>
              <p>
                We will not store your database's host and port on our servers
                unless you choose to share your connection with your team. Any
                stored host and port information will be encrypted using the
                AES-256 algorithm.
              </p>
            </li>
            <li>
              <p>We will never store your database's username and password.</p>
            </li>
          </ul>

          <h3>Disclosure to Third Parties</h3>
          <p>
            We will not share your Personal Information with third parties
            without your express consent, except in the limited circumstances
            described below:
          </p>
          <ul className="list-disc space-y-3 ml-10 pr-5">
            <li>
              <p>
                We may share your Personal Information with third party service
                providers for the limited purposes described in the section
                entitled "How Your Information is Used."
              </p>
            </li>
            <li>
              <p>
                We will share your Personal Information when required by law,
                regulation, or litigation, and as necessary for purposes of
                national security, law enforcement, or other issues of public
                importance.
              </p>
            </li>
            <li>
              <p>
                If we sell assets or are acquired by or merged with another
                entity, we may provide such entity customer information without
                obtaining your further consent. We may provide notice of such
                asset sales, acquisitions, or mergers on the Site.
              </p>
            </li>
          </ul>

          <h3>Your Choices</h3>
          <ul className="list-disc space-y-3 ml-10 pr-5">
            <li>
              <p>
                If at any time you are uncomfortable with our use of your
                Personal Information for internal marketing purposes and for the
                purpose of creating aggregate reports, you may opt-out by email
                as described in "Opting-Out or Updating Your Personal
                Information and Privacy Preferences." Note that if you opt not
                to provide us with certain mandatory information, then our
                Products and services may be unavailable to you.
              </p>
            </li>
            <li>
              <p>
                You may similarly opt out of receiving communications from us,
                although we may find it necessary to continue to communicate
                with you regarding your use of the Services.
              </p>
            </li>
            <li>
              <p>
                For our websites, you may set your browser to refuse all or some
                browser cookies, or to alert you when cookies are being sent. If
                you disable or refuse cookies, please note that some parts of
                this Site may then be inaccessible or not function properly.
              </p>
            </li>
            <li>
              <p>
                Please note that although you may be able to delete some
                information and User Content via the services, we may retain
                some information in data backups maintained in the ordinary
                course of business. We may also retain information if legally
                required to do so. Please note that we cannot be responsible for
                deleting or removing information about you that we have
                previously shared with third parties pursuant to this Privacy
                Policy.
              </p>
            </li>
          </ul>

          <h3>Governing Law</h3>
          <p>
            The terms of this Privacy Policy are governed by and in accordance
            with the laws of the state of California. You should not provide us
            with any Personal Information unless you consent to the application
            of United States law and, where applicable, California law, and to
            the use and disclosure of your information in accordance with the
            terms of this Privacy Policy.
          </p>

          <h3>
            Opting-Out or Updating Your Personal Information and Privacy
            Preferences
          </h3>
          <p>
            You have the right to access, correct and delete inaccuracies in
            your Personal Information and privacy preferences on the Services at
            any time by signing into your account and editing your Personal
            Information in your account profile. You may also do so by
            contacting us via email at{' '}
            <a href="mailto:privacy@timescale.com">privacy@timescale.com</a>.
          </p>
          <p>
            If at any time you wish to opt-out of our use of your information
            for internal marketing purposes or for compiling aggregate risk
            reports, you may do so by emailing:{' '}
            <a href="mailto:privacy@timescale.com">privacy@timescale.com</a>.
          </p>

          <h3>Privacy Complaints</h3>
          <p>
            We take our users' privacy concerns seriously. If you believe that
            we have not complied with this Privacy Policy with respect to your
            Personal Information, you may write to us at the address noted
            above.
          </p>
          <p>
            Also, please note that we are not responsible for the content or
            privacy practices of third-party websites or integrated products to
            which the Site or the Services may link. You should review the
            privacy policies of such sites before using the associated sites.
          </p>
          <p>
            The Services are intended for users in the United States and those
            not governed by privacy policies of other countries. Users outside
            the United States are advised not to disclose Personal Information
            to us.
          </p>

          <p className="text-gray-300">
            Effective <time dateTime="2024-04-03">April 3, 2024</time>
          </p>
          {/* <p className="text-muted"><%= link_to 'Archive of Previous Terms', archived_documents_path('privacy'), class: 'text-muted' %></p> */}
        </div>
      </main>

      <Footer />
    </>
  );
};

export default Privacy;
